import React from 'react'

import { SVGComponent } from '..'

function ModalHeader({ verifyScreen, title, toggle, subTitle, showCloseButton = true }) {
  return (
    <div className={`${verifyScreen ? 'pt-2 pb-0 ' : 'pt-4 pb-4 '} flex flex-top flex-between`}>
      <div className="flex flex-column">
        <div className="fs-7 fw-600 c-neutral-900">{title}</div>
        {subTitle && <div className="c-success-500 fs-3 mt-2">{subTitle}</div>}
      </div>
      {showCloseButton && (
        <div
          style={{ borderRadius: '14px' }}
          className={`${verifyScreen ? 'pt-2 pb-1 ' : ' py-1 '} px-1  c-pointer flex flex-middle nmx-1`}
          onClick={toggle}
        >
          <SVGComponent
            svgIcon="crossDark"
            height={24}
            width={24}
            className="c-pointer c-neutral-900"
          />
        </div>
      )}
    </div>
  )
}

export default ModalHeader
